<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col cols="6" class="py-0">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </v-col>
      <v-col cols="6" class="text-right">
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="12" md="12" class="px-0">
        <v-card class="pa-5" tile>
          <v-container fluid>
            <v-row>
              <v-col cols="3">
                <img :src="item.product.product_icon_url" />
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="8">
                <v-toolbar
                  color="primary"
                  dense
                >
                  <v-toolbar-title>{{ item.product.category.name }}: {{ item.product.name }}</v-toolbar-title>
                </v-toolbar>

                <v-container fluid>
                  <v-form
                    :disabled="isFinalized"
                    autocomplete="off"
                  >
                    <v-row class="mt-3">
                      <v-col cols="6">
                        <v-text-field
                          v-model="item.quantity"
                          label="Aantal"
                          :error-messages="errors.quantity"
                          autocomplete="off"
                          :suffix="isGlazingBead ? 'm¹' : 'stuks'"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" v-if="isDoor || isWindow">
                        <v-select
                          v-model="item.wood_type"
                          label="Houtsoort"
                          :items="this.isPlateDoor ? ['Okoume alustabiel', 'Okoume standaard'] : ['Mahonie']"
                          :error-messages="errors.wood_type"
                          autocomplete="off"
                          dense
                        ></v-select>
                      </v-col>
                    </v-row>

                    <v-row v-if="isDoor || isWindow">
                      <v-col cols="12">
                        <legend>Afmetingen</legend>
                      </v-col>
                      <v-col cols="6" v-if="isDoor">
                        <v-text-field
                          v-model="item.door_width"
                          label="Deurbreedte (A)"
                          :error-messages="errors.door_width"
                          autocomplete="off"
                          suffix="mm"
                          dense
                          ></v-text-field>
                      </v-col>
                      <v-col cols="6" v-if="isDoor">
                        <v-text-field
                          v-model="item.door_height"
                          label="Deurhoogte (B)"
                          :error-messages="errors.door_height"
                          autocomplete="off"
                          suffix="mm"
                          dense
                          ></v-text-field>
                      </v-col>
                      <v-col cols="6" v-if="isFrontDoor || isBackDoor">
                        <v-text-field
                          v-model="item.parapet_height"
                          label="Borstweringhoogte (C)"
                          :error-messages="errors.parapet_height"
                          autocomplete="off"
                          suffix="mm"
                          dense
                          ></v-text-field>
                      </v-col>
                      <v-col cols="6" v-if="isFrontDoor">
                        <v-text-field
                          v-model="item.intermediate_sill_height"
                          label="Bovenzijde tussendorpelhoogte (D)"
                          :error-messages="errors.intermediate_sill_height"
                          autocomplete="off"
                          suffix="mm"
                          dense
                          ></v-text-field>
                      </v-col>
                      <v-col cols="6" v-if="isFrontDoor">
                        <v-text-field
                          v-model="item.underside_intermediate_sill"
                          label="Onderzijde tussendorpelhoogte (D1)"
                          :error-messages="errors.underside_intermediate_sill"
                          autocomplete="off"
                          suffix="mm"
                          dense
                          ></v-text-field>
                      </v-col>
                      <v-col cols="6" v-if="isWindow">
                        <v-text-field
                          v-model="item.window_width"
                          label="Raambreedte"
                          :error-messages="errors.window_width"
                          autocomplete="off"
                          suffix="mm"
                          dense
                          ></v-text-field>
                      </v-col>
                      <v-col cols="6" v-if="isWindow">
                        <v-text-field
                          v-model="item.window_height"
                          label="Raamhoogte"
                          :error-messages="errors.window_height"
                          autocomplete="off"
                          suffix="mm"
                          dense
                          ></v-text-field>
                      </v-col>
                      <v-col cols="6" v-if="isDoor || isCasementWindow">
                        <v-select
                          v-model="item.direction_of_rotation"
                          label="Draairichting"
                          :error-messages="errors.direction_of_rotation"
                          autocomplete="off"
                          :items="['L1', 'R2', 'L3', 'R4']"
                          dense
                          append-outer-icon="mdi-information-outline"
                          @click:append-outer="showDirectionOfRotationInfo"
                          ></v-select>
                      </v-col>
                      <v-col cols="6" v-if="isDoor || isWindow">
                        <v-combobox
                          v-model="item.profile"
                          label="Profiel"
                          :items="this.isPlateDoor ? ['Vlak', 'V. groef', '10mm groef'] : ['Standaard profiel', 'Stopverf profiel']"
                          :error-messages="errors.profile"
                          autocomplete="off"
                          dense
                        ></v-combobox>
                      </v-col>
                      <v-col cols="6" v-if="isDoor">
                        <v-text-field
                          v-model="item.crank_hole_height"
                          label="Krukgat hoogte"
                          autocomplete="off"
                          :error-messages="errors.crank_hole_height"
                          suffix="mm"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" v-if="isDoor || isCasementWindow">
                        <v-text-field
                          v-model="item.hinge_1_height"
                          label="Scharnierhoogte 1"
                          :error-messages="errors.hinge_1_height"
                          autocomplete="off"
                          suffix="mm"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" v-if="isDoor || isCasementWindow">
                        <v-text-field
                          v-model="item.hinge_2_height"
                          label="Scharnierhoogte 2"
                          :error-messages="errors.hinge_2_height"
                          autocomplete="off"
                          suffix="mm"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" v-if="isDoor || isCasementWindow">
                        <v-text-field
                          v-model="item.hinge_3_height"
                          label="Scharnierhoogte 3"
                          :error-messages="errors.hinge_3_height"
                          autocomplete="off"
                          suffix="mm"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" v-if="isDoor || isCasementWindow">
                        <v-text-field
                          v-model="item.hinge_4_height"
                          label="Scharnierhoogte 4"
                          :error-messages="errors.hinge_4_height"
                          autocomplete="off"
                          suffix="mm"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" v-if="isFlapWindow">
                        <v-text-field
                          v-model="item.hinge_1_width"
                          label="Scharnierbreedte 1"
                          :error-messages="errors.hinge_1_width"
                          autocomplete="off"
                          suffix="mm"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" v-if="isFlapWindow">
                        <v-text-field
                          v-model="item.hinge_2_width"
                          label="Scharnierbreedte 2"
                          :error-messages="errors.hinge_2_width"
                          autocomplete="off"
                          suffix="mm"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" v-if="isFlapWindow">
                        <v-text-field
                          v-model="item.hinge_3_width"
                          label="Scharnierbreedte 3"
                          :error-messages="errors.hinge_3_width"
                          autocomplete="off"
                          suffix="mm"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" v-if="isFlapWindow">
                        <v-text-field
                          v-model="item.hinge_4_width"
                          label="Scharnierbreedte 4"
                          :error-messages="errors.hinge_4_width"
                          autocomplete="off"
                          suffix="mm"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" v-if="isFrontDoor">
                        <v-select
                          v-model="item.nosing_sill"
                          label="Weldorpel"
                          :error-messages="errors.nosing_sill"
                          autocomplete="off"
                          :items="['Standaard - los meegeleverd', 'Paardekont - los meegeleverd', 'n.v.t.']"
                          dense
                          ></v-select>
                      </v-col>
                      <v-col cols="6" v-if="isDoor">
                        <v-combobox
                          v-model="item.door_thickness"
                          label="Deurdikte"
                          :items="['40', '56']"
                          :error-messages="errors.door_thickness"
                          autocomplete="off"
                          suffix="mm"
                          dense
                        ></v-combobox>
                      </v-col>
                      <v-col cols="6" v-if="isWindow">
                        <v-combobox
                          v-model="item.window_thickness"
                          label="Raamdikte"
                          :items="['56*80', '56*90']"
                          :error-messages="errors.window_thickness"
                          autocomplete="off"
                          suffix="mm"
                          dense
                        ></v-combobox>
                      </v-col>
                      <v-col cols="6" v-if="isWindow || ((isFrontDoor || isBackDoor) && item.door_thickness == '56')">
                        <v-select
                          v-model="item.framework"
                          label="Kader"
                          :error-messages="errors.framework"
                          autocomplete="off"
                          :items="['Kaderdichting', isFrontDoor ? 'Oud-model verjonging binnen' : 'Oud-model verjonging buiten']"
                          dense
                          ></v-select>
                      </v-col>
                    </v-row>

                    <v-row v-if="isDoor || isWindow">
                      <v-col cols="12">
                        <legend>Beslag, hang & sluitwerk</legend>
                      </v-col>
                      <v-col cols="6" v-if="isDoor">
                        <v-combobox
                          v-model="item.lock_type"
                          label="Slot type"
                          :items="['4119', '4139', 'n.v.t.']"
                          autocomplete="off"
                          :error-messages="errors.lock_type"
                          dense
                        ></v-combobox>
                      </v-col>
                      <v-col cols="6" v-if="isDoor || isWindow">
                        <v-select
                          v-model="item.hinge_type"
                          label="Scharniertype"
                          :error-messages="errors.hinge_type"
                          autocomplete="off"
                          :items="['89x89', '76x76', 'n.v.t.']"
                          dense
                          ></v-select>
                      </v-col>
                      <v-col cols="6" v-if="isDoor">
                        <v-combobox
                          v-model="item.garnish_type"
                          label="Garnituurtype"
                          :error-messages="errors.garnish_type"
                          autocomplete="off"
                          :items="['Hoppe Londen', 'n.v.t.']"
                          dense
                        ></v-combobox>
                      </v-col>
                      <v-col cols="6" v-if="isDoor">
                        <v-select
                          v-model="item.casement_fastener"
                          label="Raambomen"
                          :error-messages="errors.casement_fastener"
                          autocomplete="off"
                          :items="['Drukknop', 'Afsluitbaar', 'n.v.t.']"
                          dense
                        ></v-select>
                      </v-col>
                      <v-col cols="6" v-if="isFrontDoor">
                        <v-select
                          v-model="item.mailbox_type"
                          label="Brievenbustype"
                          :error-messages="errors.mailbox_type"
                          autocomplete="off"
                          :items="['AMI geïsoleerd', 'AXA klep', 'Kunststof haarborstel', 'n.v.t.']"
                          dense
                          ></v-select>
                      </v-col>
                      <v-col cols="6" v-if="isWindow">
                        <v-select
                          v-model="item.spreader_type"
                          label="Uitzetter type"
                          :error-messages="errors.spreader_type"
                          autocomplete="off"
                          :items="(isCasementWindow ? ['Habilis uitzetter', 'Telescoop uitzetter'] : ['Combi uitzetter afsluitbaar', 'Combi uitzetter niet afsluitbaar']).concat(['n.v.t.'])"
                          dense
                        ></v-select>
                      </v-col>
                    </v-row>

                    <v-row v-if="isDoor || isWindow">
                      <v-col cols="12">
                        <legend>Glas</legend>
                      </v-col>
                      <v-col cols="6" v-if="isFrontDoor || isBackDoor || isWindow">
                        <v-combobox
                          v-model="item.glass_type"
                          label="Glas"
                          :items="['HR++5-15-4', 'HR++3.3.1-13.3.3.1'].concat(isFrontDoor || isBackDoor ? ['4mm blank', '4mm draadglas'] : []).concat(['n.v.t.'])"
                          autocomplete="off"
                          :error-messages="errors.glass_type"
                          dense
                        ></v-combobox>
                      </v-col>
                      <v-col cols="6" v-if="isCasementWindow">
                        <v-select
                          v-model="item.glazing_type"
                          label="Beglazing"
                          :items="['Binnen', 'Buiten']"
                          autocomplete="off"
                          :error-messages="errors.glazing_type"
                          dense
                        ></v-select>
                      </v-col>
                    </v-row>


                    <v-row v-if="isDoor || isWindow">
                      <v-col cols="12">
                        <legend>Conservering</legend>
                      </v-col>
                      <v-col cols="6" v-if="isDoor || isWindow">
                        <v-combobox
                          v-model="item.color_inside"
                          label="Kleur binnenkant"
                          :error-messages="errors.color_inside"
                          autocomplete="off"
                          :items="['RAL9001', 'RAL9010', 'RAL7016', 'RAL7046', 'RAL6009']"
                          dense
                        ></v-combobox>
                      </v-col>
                      <v-col cols="6" v-if="isDoor || isWindow">
                        <v-combobox
                          v-model="item.color_outside"
                          label="Kleur buitenkant"
                          :error-messages="errors.color_outside"
                          autocomplete="off"
                          :items="['RAL9001', 'RAL9010', 'RAL7016', 'RAL7046', 'RAL6009']"
                          dense
                        ></v-combobox>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-textarea
                          v-model="item.remarks"
                          label="Opmerkingen"
                          :error-messages="errors.remarks"
                          autocomplete="off"
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>

                    <v-row v-if="isGlazingBead">
                      <v-col cols="12">
                        <p>Glaslatten worden standaard wit gegrond geleverd, andere kleuren in overleg mogelijk.</p>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" class="text-right">
                        <v-btn v-if="!isFinalized" color="primary" @click="updateItem">Opslaan</v-btn>
                      </v-col>
                    </v-row>
                    
                  </v-form>
                </v-container>

              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//import Vue from 'vue'
import ApiService from '@/services/api.service'
import goTo from 'vuetify/es5/services/goto'

export default {
  components: {
  },
  data: () => ({

    item: {
      product: {
        category: {}
      },
      project: {},
    },

    errors: {},

  }),

  computed: {
    projectId() {
      return Number(this.item.project_id)
    },
    isFinalized() {
      return this.item.project.status == 20
    },
    lineId() {
      return Number(this.$route.params.lineId)
    },
    breadcrumbs() {
      return [{
        text: 'Projecten',
        disabled: false,
        to: { name: 'projects' },
      }, {
        text: 'Project',
        disabled: false,
        to: {
          name: 'project',
          params: {
            projectId: this.projectId,
          },
        },
        exact: true,
      }, {
        text: 'Regel',
        disabled: true,
      }]
    },
    isFrontDoor() {
      return this.item.product.template == 'front_door'
    },
    isBackDoor() {
      return this.item.product.template == 'back_door'
    },
    isPlateDoor() {
      return this.item.product.template == 'plate_door'
    },
    isCasementWindow() {
      return this.item.product.template == 'casement_window'
    },
    isFlapWindow() {
      return this.item.product.template == 'flap_window'
    },
    isGlazingBead() {
      return this.item.product.template == 'glazing_bead'
    },
    isDoor() {
      return this.isFrontDoor || this.isBackDoor || this.isPlateDoor
    },
    isWindow() {
      return this.isCasementWindow || this.isFlapWindow
    },
  },



  created() {
    this.fetchItem()

  },
  methods: {
    toProject() {
      this.$router.push({
        name: 'project',
        params: {
          projectId: this.projectId,
        },
      })
    },
    showDirectionOfRotationInfo() {
      window.open('/files/aanzicht_draairichtingen.pdf', '_blank')
    },
    fetchItem() {
      this.$store.dispatch('session/showLoader')
      ApiService.view(`/project-lines/${this.lineId}`, {
        params: {
          expand: 'product,product.category,project'
        },
      }).then(item => {
        item.quantity = Number(item.quantity)
        this.item = item
      }).catch((err) => {
        console.log(err)
        this.$router.push({ name: 'projects' })
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    updateItem() {
      this.errors = {}
      this.$store.dispatch('session/showLoader')
      ApiService.update(`/project-lines/${this.lineId}`, {
        ...this.item,
      }).then(() => {
        this.toProject()
      }).catch(errors => {
        this.errors = errors
        // scroll to error
        this.$nextTick(() => {
          let el = document.querySelector(".v-messages.error--text:first-of-type");
          if (el) {
            let height = el.getBoundingClientRect().top + window.scrollY
            goTo(height - 125)
          }
        })
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
  },
}
</script>